import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";
import { Organization } from "../utils/types";

export const getOrganization = async (organization_id: string) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    try {
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/`;
      const response = await axios.get(endpoint, { headers });
      // console.log("Organization data:", response.data);

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error("Data retrieval failed:", response.data);
        return { success: false, data: response.data };
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      return { success: false, data: error };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

// Create new organization
export const createOrganization = async (organization: Organization) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    try {
      const endpoint = `${baseUrl}/core/organizations/`;
      const response = await axios.post(endpoint, organization, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error("Creation failed:", response.data);
        return { success: false, data: response.data };
      }
    } catch (error) {
      console.error("Error creating organization:", error);
      return { success: false, data: error };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

// Update organization
export const updateOrganization = async (
  organization_id: string,
  organization: Organization
) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    try {
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/`;
      const response = await axios.put(endpoint, organization, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error("Update failed:", response.data);
        return { success: false, data: response.data };
      }
    } catch (error) {
      console.error("Error updating organization:", error);
      return { success: false, data: error };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

// Delete organization
export const deleteOrganization = async (organization_id: string) => {
  let token = await getAuthToken();
  try {
    if (!token) return { success: false, data: "Token does not exist" };

    const headers = { Authorization: "Bearer " + token.data };
    try {
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/`;
      const response = await axios.delete(endpoint, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error("Deletion failed:", response.data);
        return { success: false, data: response.data };
      }
    } catch (error) {
      console.error("Error deleting organization:", error);
      return { success: false, data: error };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};
